jQuery(document).ready(function ($) {

  if ($(".nf-form-cont").length > 0) {

    var ninjaFormsCustomFieldController = Marionette.Object.extend({
      initialize: function () {
        // On the Form Submission's field validaiton...
        var submitChannel = Backbone.Radio.channel("submit");
        this.listenTo(submitChannel, "validate:field", this.validateRequired);
    
        // on the Field's model value change...
        var fieldsChannel = Backbone.Radio.channel("fields");
        this.listenTo(fieldsChannel, "change:modelValue", this.validateRequired);
      },
    
      validateRequired: function (model) {
        var formID = model.attributes.formID;
        var modelID = model.get("id");
        var errorID = "required-error";
        var fieldsChannel = Backbone.Radio.channel("fields");
    
        var customMessages = {
          // Kontaktformular
          1: { // FormID
            2: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
            3: "Bitte geben Sie eine Nachricht ein.",
            184: "Bitte akzeptieren Sie die Datenschutzerklärung.",
          },
          // Veranstaltungs-Anmeldung
          2: { // FormID
            45: "Bitte geben Sie Ihren Vornamen ein.",
            44: "Bitte geben Sie Ihren Nachnamen ein.",
            46: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
            51: "Bitte bestätigen Sie, dass Sie die AGB zur Kenntnis genommen haben.",
          },
        };
    
        // console.log(model)
    
        // change error messages
        if (!model.get("value")) {
          for (var key of Object.keys(customMessages)) {
            if (formID == key) {
              for (var key2 of Object.keys(customMessages[key])) {
                if (modelID == key2) {
                  // set custom message
                  fieldsChannel.request(
                    "add:error",
                    modelID,
                    errorID,
                    customMessages[key][key2]
                  );
                }
              }
            }
          }
        }
    
        // move error message to top: after-form-content => before-form-content
        $(".nf-after-form-content nf-section .nf-form-errors").prependTo(".nf-before-form-content nf-section");
    
        // wrap title
        if ($(".nf-before-form-content nf-section .nf-error-field-errors .nf-error-field-errors-title").length == 0) {
          $(".nf-before-form-content nf-section .nf-error-field-errors").wrapInner("<div class='nf-error-field-errors-title'></div>");
        }
    
        // remove existing ul
        $(".nf-before-form-content .nf-error-field-errors ul").remove();
    
        // add list with messages
        var errorMessagesList = $("#nf-form-"+formID+"-cont .nf-mp-body .nf-error-required-error").map(function() {
          return this.innerHTML;
        }).get();
    
        if ((errorMessagesList.length > 0)) {
          if ($(".nf-before-form-content .nf-error-field-errors ul").length == 0) {
            $("<ul></ul>").appendTo(".nf-before-form-content .nf-error-field-errors");
          }
    
          for (var key of Object.keys(errorMessagesList)) {
            $("<li>"+errorMessagesList[key]+"</li>").appendTo(".nf-before-form-content .nf-error-field-errors ul");
          }
    
          // scroll to messages
          const errorsPosition = $(".nf-before-form-content nf-section .nf-form-errors").offset();
          $('html, body').animate({ scrollTop: errorsPosition.top - 100 }, 300);
        }
        
        // console.log(errorMessagesList);    
      },
    });

    // Instantiate our custom field's controller, defined above.
    new ninjaFormsCustomFieldController();
  }

});
